// Three editorial CONCEPTS (not real client work). Radical honesty: no client
// names, owners, KPIs or testimonials. The site itself is the portfolio.
export const projects = [
  {
    slug: "restaurante-gastronomico",
    n: "001",
    year: "MMXXV",
    disciplines: ["Diseño web", "Dirección creativa", "Copywriting"],
    sector: "Restaurante gastronómico",
    card: "Restaurante gastronómico",
    cta: "Descubrir proyecto",
    titular: "La experiencia empieza mucho antes de llegar a la mesa.",
    descripcion: [
      "En un restaurante gastronómico, la web no solo informa. También despierta curiosidad, transmite personalidad y prepara la experiencia antes de la primera visita.",
      "Este concepto editorial transforma la identidad del restaurante en una experiencia digital elegante, donde la fotografía, la tipografía y el ritmo visual cuentan la historia del espacio.",
    ],
    incluye: ["Diseño web", "Dirección creativa", "Copywriting", "Arquitectura de contenidos", "Optimización móvil"],
    mockup: "restaurant",
    accent: "#FF6B2C",
    gallery: [
      "https://images.pexels.com/photos/30479386/pexels-photo-30479386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
      "https://images.pexels.com/photos/2313686/pexels-photo-2313686.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
      "https://images.pexels.com/photos/8629094/pexels-photo-8629094.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    ],
  },
  {
    slug: "clinica-dental",
    n: "002",
    year: "MMXXV",
    disciplines: ["Diseño web", "UX / UI", "Arquitectura"],
    sector: "Clínica dental",
    card: "Clínica dental",
    cta: "Descubrir proyecto",
    titular: "La confianza también se diseña.",
    descripcion: [
      "Elegir una clínica es una decisión basada en la confianza. Este concepto prioriza la claridad, la serenidad y una experiencia intuitiva que transmite profesionalidad desde el primer instante.",
      "Cada detalle está pensado para que el paciente encuentre la información que necesita con facilidad y perciba la misma tranquilidad que espera recibir durante su visita.",
    ],
    incluye: ["Diseño web", "UX/UI", "Arquitectura de contenidos", "Copywriting", "Optimización móvil"],
    mockup: "dental",
    accent: "#7BA6C2",
    gallery: [
      "https://images.pexels.com/photos/6812453/pexels-photo-6812453.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
      "https://images.pexels.com/photos/3845981/pexels-photo-3845981.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
      "https://images.pexels.com/photos/305565/pexels-photo-305565.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    ],
  },
  {
    slug: "estudio-interiorismo",
    n: "003",
    year: "MMXXV",
    disciplines: ["Diseño web", "Dirección creativa", "Portfolio"],
    sector: "Estudio de interiorismo",
    card: "Estudio de interiorismo",
    cta: "Descubrir proyecto",
    titular: "Los espacios también cuentan historias.",
    descripcion: [
      "Cuando el trabajo habla por sí solo, la web debe convertirse en un escenario que permita apreciarlo sin distracciones. Este concepto editorial utiliza el espacio, la tipografía y el ritmo visual para que cada proyecto sea el verdadero protagonista.",
      "El resultado es una experiencia limpia, elegante y diseñada para transmitir sensibilidad, criterio y atención al detalle.",
    ],
    incluye: ["Diseño web", "Dirección creativa", "Portfolio editorial", "Copywriting", "Optimización móvil"],
    mockup: "interior",
    accent: "#5F7A5A",
    gallery: [
      "https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
      "https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
      "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    ],
  },
];

export const getProject = (slug) => projects.find((p) => p.slug === slug);

export const getNeighbours = (slug) => {
  const idx = projects.findIndex((p) => p.slug === slug);
  if (idx < 0) return { prev: null, next: null };
  return {
    prev: projects[(idx - 1 + projects.length) % projects.length],
    next: projects[(idx + 1) % projects.length],
  };
};
